import { faPlusCircle, faSave, faTimes } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import moment from 'moment';
import { withSnackbar } from 'notistack';
import React, { useEffect, useState, useRef, Fragment, CSSProperties, SyntheticEvent } from 'react';
import Button from 'react-bootstrap/Button';
import Card from 'react-bootstrap/Card';
import Col from 'react-bootstrap/Col';
import Container from 'react-bootstrap/Container';
import Form from 'react-bootstrap/Form';
import Row from 'react-bootstrap/Row';
import WindowedSelect, { WindowedMenuList, createFilter } from "react-windowed-select";
import { GetAllDropDownData, GetDocks, InsertLog } from '../services/api';
import { LogEntry } from '../types/logEntry';
import { ProjectLogLookup } from '../types/projectLogLookup';
import CreatableSelect from 'react-select/creatable';
import { debug } from 'console';

const EntrySection = (props: any) => {
    const formRef = useRef<any>();
    const firstSelectRef = useRef<any>();
    const customFilter = createFilter({ matchFrom: 'start' });
    let buttonNum = 1

    const [submitting, setSubmitting] = useState<boolean>(false);
    const [state, setState] = useState<any>({
        customer: null,
        barges: [],
        bargesControl: null,
        boat: null,
        product: null,
        operation: null,
        location: null,
        port: null,
        dockNo: null,
        rep: null,
        draft: null,
        po: null,
        eta: null
    });
    const [optionsData, setOptionsData] = useState<ProjectLogLookup>({
        project_log_lookups: {
            barges: [],
            customers: [],
            products: [],
            boats: [],
            locations: [],
            operations: [],
            ports: [],
            projectdesc: [],
            docks: [],
        }
    });

    useEffect(() => {
        GetAllDropDownData()
            .then(res => {
                setOptionsData(JSON.parse(res));
            });

        if (firstSelectRef && firstSelectRef.current)
            firstSelectRef.current.focus();
    }, []);

    const handleChange = (newValue: any, actionMeta: any) => {
        if((actionMeta.name == 'location' && state.port) || (actionMeta.name == 'port' && state.location)){
            var dockData = {
                locationRowId: actionMeta.name == 'location' ? newValue.value : state.location.value,
                portRowId: actionMeta.name == 'port' ? newValue.value : state.port.value,
            }

            GetDocks(dockData)
                .then(res => {
                    var dockDataFormatted = res.map((e: any) => ({
                        label: e.dockName,
                        value: e.dockName,
                    }));

                    var newProjectLogLookups = {
                        ...optionsData.project_log_lookups,
                        docks: dockDataFormatted,
                    }

                    setOptionsData({project_log_lookups: newProjectLogLookups});
                });
        }
        // Do weird stuff to barges
        if (actionMeta.name === 'barge') {
            if (newValue) {
                setState({
                    ...state,
                    bargesControl: newValue,
                    barges: newValue.map((obj: any) => obj.label)
                });
            } else {
                setState({
                    ...state,
                    bargesControl: [],
                    barges: []
                });
            }
        } 
        else {
            setState({
                ...state,
                [actionMeta.name]: newValue
            });
        }
    }

    const handleInputChange = (event: any) => {
        setState({
            ...state,
            [event.currentTarget.name]: event.currentTarget.value
        });
    }

    const parseInt = (x: string) => {
        let parsed = Number.parseInt(x, 10);

        if (Number.isNaN(parsed))
            parsed = -1;

        return parsed;
    }



    const clearForm = () => {
        setState({
            customer: null,
            barges: [],
            bargesControl: null,
            boat: null,
            product: null,
            operation: null,
            location: null,
            port: null,
            rep: null,
            draft: null,
            po: null,
            eta: null,
            project_desc: null
        });

        if (formRef && formRef.current)
            formRef.current.reset();

        if (firstSelectRef && firstSelectRef.current)
            firstSelectRef.current.focus();

        setSubmitting(false);
    }

    const handleSubmit = (event: any) => {
        const t = event.target;
        const isForce = buttonNum == 2;

        setSubmitting(true);
        event.preventDefault();

        var log: LogEntry = {
            detailsId: props.id,
            headerId: props.headerId,
            createTime: moment.utc().format(),
            customerName: state.customer != null ? state.customer.label : '',
            customerId: state.customer != null ? state.customer.value : '00000000-0000-0000-0000-000000000000',
            customerRep: t.rep.value,
            barges: state.barges.join(","),
            boatName: state.boat != null ? state.boat.label : '',
            boatId: state.boat != null ? state.boat.value : '00000000-0000-0000-0000-000000000000',
            productName: state.product != null ? state.product.label : '',
            draft: t.draft.value,
            poNumber: t.po.value,
            h2S: t.h2s.checked,
            eta: t.eta.value,
            firm: t.firm.checked,
            comment: t.notes.value,
            username: props.username,
            portId: state.port != null ? state.port.value : '00000000-0000-0000-0000-000000000000',
            portName: state.port != null ? state.port.label : '',
            locationId: state.location != null ? state.location.value : '00000000-0000-0000-0000-000000000000',
            locationName: state.location != null ? state.location.label : '',
            operationId: t.operation != null ? parseInt(t.operation.value) : 0,
            projectNumber: '',
            dockNo: t.dockNo.value,
            dockLoad: t.dockLoad.value,
            alias: t.alias.value,
            projectDesc: t.project_desc.value,
            trip: t.trip.checked
        }

        InsertLog(log, isForce).then((rowsAffected) => {
            if (rowsAffected > 0) {
                props.enqueueSnackbar('Successful', {
                    variant: 'success',
                });

                log.detailsId = rowsAffected;
                if (!log.trip)
                    clearForm();
                else {
                    state.draft = "";
                    state.operation = null;
                    t.trip.checked = false;
                    t.draft.value = "";
                    state.po = "";
                    t.h2s.checked = false;
                    t.firm.checked = false;
                    t.notes.value = "";
                    state.port = null;
                    state.location = null;
                    t.dockNo.value = "";
                    t.dockLoad.value = "";
                    t.alias.value = "";
                    state.project_desc = "";
                    state.eta = "";
                }

                props.pushLogEntry(log);
            } else {
                props.enqueueSnackbar('An error occured.', {
                    variant: 'error',
                });

                setSubmitting(false);
            }
        });


        return false;
    }

    const selectStyles = {
        control: (base: any) => ({
            ...base,
            backgroundColor: 'rgba(255, 0, 0, 0.15)'
        })
    }

    const inputStyles: CSSProperties = {
        backgroundColor: 'rgba(255, 0, 0, 0.15)'
    }

    return (

        <Container style={{ marginTop: '10px', paddingBottom: '10px' }} fluid>
            <form ref={formRef} onSubmit={handleSubmit} noValidate >
                <Row>
                    <Col>
                        <Card>
                            <Card.Body>
                                <Form.Row>
                                    <Col xs={2}>
                                        <Form.Group>
                                            <Form.Label>Customer</Form.Label>
                                            <WindowedSelect
                                                ref={firstSelectRef}
                                                name="customer"
                                                filterOption={customFilter}
                                                autoFocus
                                                isClearable
                                                value={state.customer}
                                                onChange={handleChange}
                                                options={optionsData.project_log_lookups.customers}
                                                styles={state.customer === null && submitting && selectStyles || undefined}
                                            />
                                        </Form.Group>
                                    </Col>
                                    <Col>
                                        <Form.Group>
                                            <Form.Label>Customer Rep</Form.Label>
                                            <Form.Control
                                                name="rep"
                                                type="text"
                                                placeholder="Customer Rep"
                                                value={state.rep}
                                                onChange={handleInputChange}
                                                style={!state.rep && submitting && inputStyles || undefined}
                                            />
                                        </Form.Group>
                                    </Col>
                                    <Col xs={3} md={2}>
                                        <Form.Group>
                                            <Form.Label>Barge(s)</Form.Label>
                                            <CreatableSelect
                                                name="barge"
                                                filterOption={customFilter}
                                                isMulti
                                                isClearable
                                                value={state.bargesControl}
                                                options={optionsData.project_log_lookups.barges}
                                                components={{ MenuList: WindowedMenuList }}
                                                onChange={handleChange}
                                                styles={(state.bargesControl === null || state.bargesControl.length === 0) && submitting && selectStyles || undefined}
                                            />
                                        </Form.Group>
                                    </Col>
                                    <Col>
                                        <Form.Group>
                                            <Form.Label>Boat</Form.Label>
                                            <WindowedSelect
                                                name="boat"
                                                filterOption={customFilter}
                                                isClearable
                                                value={state.boat}
                                                onChange={handleChange}
                                                options={optionsData.project_log_lookups.boats}
                                                styles={state.boat === null && submitting && selectStyles || undefined}
                                            />
                                        </Form.Group>
                                    </Col>
                                    <Col>
                                        <Form.Group>
                                            <Form.Label>Location</Form.Label>
                                            <WindowedSelect
                                                name="location"
                                                filterOption={customFilter}
                                                isClearable
                                                value={state.location}
                                                onChange={handleChange}
                                                options={optionsData.project_log_lookups.locations}
                                                styles={state.location === null && submitting && selectStyles || undefined}
                                            />
                                        </Form.Group>
                                    </Col>
                                    <Col>
                                        <Form.Group>
                                            <Form.Label>Port</Form.Label>
                                            <WindowedSelect
                                                name="port"
                                                filterOption={customFilter}
                                                isClearable
                                                value={state.port}
                                                onChange={handleChange}
                                                options={optionsData.project_log_lookups.ports}
                                                styles={state.port === null && submitting && selectStyles || undefined}
                                            />
                                        </Form.Group>
                                    </Col>
                                    <Col>
                                        <Form.Group>
                                            <Form.Label>Dock Number</Form.Label>
                                            <WindowedSelect
                                                name="dockNo"
                                                filterOption={customFilter}
                                                isClearable
                                                value={state.dockNo}
                                                onChange={handleChange}
                                                options={optionsData.project_log_lookups.docks}
                                                styles={state.dockNo === null && submitting && selectStyles || undefined}
                                            />
                                        </Form.Group>
                                    </Col>
                                </Form.Row>
                                <Form.Row>
                                    <Col>
                                        <Form.Group>
                                            <Form.Label>Operation</Form.Label>
                                            <WindowedSelect
                                                name="operation"
                                                filterOption={customFilter}
                                                isClearable
                                                value={state.operation}
                                                onChange={handleChange}
                                                options={optionsData.project_log_lookups.operations}
                                                styles={state.operation === null && submitting && selectStyles || undefined}
                                            />
                                        </Form.Group>
                                    </Col>
                                    <Col>
                                        <Form.Group>
                                            <Form.Label>Product</Form.Label>
                                            <WindowedSelect
                                                name="product"
                                                filterOption={customFilter}
                                                isClearable
                                                value={state.product}
                                                onChange={handleChange}
                                                options={optionsData.project_log_lookups.products}
                                                styles={state.product === null && submitting && selectStyles || undefined}
                                            />
                                        </Form.Group>
                                    </Col>
                                    <Col>
                                        <Form.Group>
                                            <Form.Label>Product Alias</Form.Label>
                                            <Form.Control name="alias" type="text" placeholder="Product Alias" />
                                        </Form.Group>
                                    </Col>
                                    <Col>
                                        <Form.Group>
                                            <Form.Label>Draft</Form.Label>
                                            <Form.Control
                                                name="draft"
                                                type="text"
                                                placeholder="Enter Draft"
                                                value={state.draft}
                                                onChange={handleInputChange}
                                                style={!state.draft && submitting && inputStyles || undefined}
                                            />
                                        </Form.Group>
                                    </Col>

                                    <Col>
                                        <Form.Group>
                                            <Form.Label>Deck Load</Form.Label>
                                            <Form.Control name="dockLoad" type="text" placeholder="Deck Load" />
                                        </Form.Group>
                                    </Col>

                                    <Col>
                                        <Form.Group>
                                            <Form.Label>PO</Form.Label>
                                            <Form.Control
                                                name="po"
                                                type="text"
                                                placeholder="Enter PO #"
                                                value={state.po}
                                                onChange={handleInputChange}
                                            />
                                        </Form.Group>
                                    </Col>
                                </Form.Row>

                                <Form.Row>

                                    <Col xs={2}>
                                        <Form.Group>
                                            <Form.Label>ETA</Form.Label>
                                            <Form.Control
                                                name="eta"
                                                type="text"
                                                placeholder="Enter ETA"
                                                value={state.eta}
                                                onChange={handleInputChange}
                                                style={!state.eta && submitting && inputStyles || undefined}
                                            />
                                        </Form.Group>
                                    </Col>

                                    <Col xs={1}>
                                        <Form.Group>
                                            <Form.Label>H2S</Form.Label>
                                            <div key={`inline-checkbox`} className="mb-3">
                                                <Form.Check name="h2s" custom inline label="Has H2S" type='checkbox' id={`inline-checkbox-1`} />
                                            </div>
                                        </Form.Group>
                                    </Col>
                                    <Col xs={1}>
                                        <Form.Group>
                                            <Form.Label>Firm</Form.Label>
                                            <div key={`inline-checkbox`} className="mb-3">
                                                <Form.Check name="firm" custom inline label="Is Firm" type='checkbox' id={`inline-checkbox-2`} />
                                            </div>
                                        </Form.Group>
                                    </Col>
                                    <Col xs={1}>
                                        <Form.Group>
                                            <Form.Label>Trip?</Form.Label>
                                            <div key={`inline-checkbox`} className="mb-3">
                                                <Form.Check name="trip" custom inline label="Trip?" type='checkbox' id={`inline-checkbox-3`} />
                                            </div>
                                        </Form.Group>
                                    </Col>

                                    <Col xs={3}>
                                        <Form.Group>
                                            <Form.Label>Project Desc</Form.Label>
                                            <WindowedSelect
                                                name="project_desc"
                                                filterOption={customFilter}
                                                isClearable
                                                value={state.project_desc}
                                                onChange={handleChange}
                                                options={optionsData.project_log_lookups.projectdesc}
                                                styles={state.project_desc === null && submitting && selectStyles || undefined}
                                            />
                                        </Form.Group>
                                    </Col>

                                    <Col>
                                        <Form.Group>
                                            <Form.Label>Comments</Form.Label>
                                            <Form.Control name="notes" type="text" placeholder="Enter Comments" />
                                        </Form.Group>
                                    </Col>
                                </Form.Row>

                                <Form.Row className="justify-content-md-center">
                                    <Col xs="auto">
                                        <Button type="submit" variant="primary" onClick={() => (buttonNum = 1)} 
                                            style={{ backgroundColor: '#41b6e6', borderColor: '#41b6e6', marginRight: '10px' }}>
                                            <FontAwesomeIcon icon={faSave} /> Save
                                        </Button>
                                        
                                    </Col>
                                </Form.Row>
                            </Card.Body>
                        </Card>
                    </Col>
                </Row>
            </form>
        </Container>
    );
}

export default withSnackbar(EntrySection);